import React from 'react'
import styled from '@emotion/styled'
import { isReactNativeApp } from '@mobi/web-native-comms/web'
import { Button } from '@mobi/component-library/Base/Buttons'
import type { Contract } from '@mobi/web-native-comms'
import {
  checkNotificationStatusAsync,
  ShowNotificationAuthPopup,
} from '@core/Components/PushNotification/NotificationAuthPopup'
import { ExpandableToolboxSection } from '../Toolbox'

type Response = Contract['RESPONSE_PUSH_AUTH_STATUS']

export const Notifications = () => {
  const [authStatus, setAuthStatus] = React.useState<Response['status']>('NotDetermined')
  const [fcmToken, setFcmToken] = React.useState<Response['fcmRegistrationToken']>('None')

  const getPushAuthStatus = () => {
    checkNotificationStatusAsync().then(response => {
      if (response.status !== 'Authorized') {
        ShowNotificationAuthPopup({
          reason: 'Notifications must be enabled to set race alerts',
          notificationAuthStatus: response.status,
        })
      }

      setAuthStatus(response.status)
      setFcmToken(response.fcmRegistrationToken)
    })
  }

  return (
    <ExpandableToolboxSection heading='Firebase Cloud Messaging (FCM)'>
      <DataListStyled>
        <dt>Authorization:</dt>
        <dd>
          <span>{authStatus}</span>
        </dd>
        <dt>FCM Token:</dt>
        <dd>
          <span>{fcmToken}</span>
        </dd>

        <Button size='xs' onClick={getPushAuthStatus} disabled={!isReactNativeApp}>
          Get Auth Status
        </Button>
      </DataListStyled>
    </ExpandableToolboxSection>
  )
}

const DataListStyled = styled.dl({
  overflowY: 'scroll',
  maxHeight: '20rem',
  fontSize: '14px',
})
